import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ddbf6fca&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ddbf6fca&prod&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=ddbf6fca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbf6fca",
  null
  
)

export default component.exports